import Grid2 from '@mui/material/Grid2';
import ArchiveFolderCard from './ArchiveFolderCard';
import ArchiveWorkflowCard from './ArchiveWorkflowCard';
import type { ArchiveItem } from './archive.types';
import type { FolderWorkflowData } from '../utils/listView.utils';

interface ArchiveCardViewProps {
  items: ArchiveItem[];
  onRestore: (id: string, type: 'workflow' | 'folder') => void;
  restoringIds?: Set<string>;
  folderFileCounts: Map<string, number>;
  archiveFolderData: FolderWorkflowData;
}

const ArchiveCardView = ({
  items,
  onRestore,
  restoringIds,
  folderFileCounts,
  archiveFolderData,
}: ArchiveCardViewProps) => (
  <Grid2 container spacing={2} data-testid="archive-card-view-container" sx={{ height: '100%' }}>
    {items.map((item) =>
      item.itemType === 'folder' ? (
        <ArchiveFolderCard
          key={item.id}
          item={item}
          onRestore={onRestore}
          isRestoring={restoringIds?.has(item.id)}
          folderFileCount={folderFileCounts.get(item.id) ?? 0}
          folderData={archiveFolderData[item.id]}
        />
      ) : (
        <ArchiveWorkflowCard key={item.id} item={item} onRestore={onRestore} isRestoring={restoringIds?.has(item.id)} />
      ),
    )}
  </Grid2>
);

export default ArchiveCardView;
